import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import PropTypes from "prop-types";
import pptbg from "../assets/pptbg.png";
import pptbg800 from "../assets/pptbg-800.png";
import pptbg400 from "../assets/pptbg-400.png";
import { useSlideContext } from "./SlideContext";
import { useState, useEffect } from "react";

/* global ResizeObserver, setTimeout */

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
    maxWidth: "900px",
  },
  frame: {
    border: "1px solid black",
    width: "100%",
    maxWidth: "800px",
    aspectRatio: "16 / 9",
  },
  header: {
    background: "#ccc",
    width: "100%",
    height: "auto",
  },
  content: {
    display: "flex",
    border: "1px solid #c5c5c5",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
    background: "#dfdfdf",
  },
});

const PPTWindow = ({ slideId }) => {
  const styles = useStyles();
  const { setPPTFrame } = useSlideContext();
  const [frame, setFrame] = useState(null);

  useEffect(() => {
    if (!frame) return;

    const updateFrame = () => {
      if (!frame) return;
      const root = frame.closest(`.pptwindow-root`);
      const rootRect = root ? root.getBoundingClientRect() : { x: 0, y: 0 };
      const rect = frame.getBoundingClientRect();

      setPPTFrame({
        width: frame.clientWidth,
        height: frame.clientHeight,
        x: rect.x - rootRect.x,
        y: rect.y - rootRect.y,
      });
    };

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === frame) {
          updateFrame();
        }
      }
    });

    observer.observe(frame);
    setTimeout(updateFrame, 50);

    return () => {
      observer.disconnect();
    };
  }, [setPPTFrame, frame]);

  return (
    <div className={styles.root + " pptwindow-root"}>
      <img
        className={styles.header}
        alt="PowerPoint header"
        src={pptbg}
        srcSet={`${pptbg400} 400w, ${pptbg800} 800w, ${pptbg} 1226w`}
        sizes="(max-width: 900px) 100vw, 900px"
      />
      <div className={styles.content}>
        <iframe
          ref={setFrame}
          allow="clipboard-read;clipboard-write"
          className={styles.frame}
          src={"./embeddable.html?gridd_data_id=onboarding_slide" + slideId}
          title="Gridd"
          spellCheck="false"
        ></iframe>
      </div>
    </div>
  );
};

PPTWindow.propTypes = {
  slideId: PropTypes.number.isRequired,
};

export default PPTWindow;
